import type { Schema } from 'effect';

import { PaymentRequestjsonldsyliusshoppaymentrequestshow } from '../gen/rcprofi';
import { PaymentRequestExtended as PaymentRequestExtendedBase } from '@vs-shop/schemas/domain/paymentRequest';
import { overrideSchema } from '@vs-shop/schemas/openapi/overrideSchema';

/**
 * RcProfi's strict payment-request boundary. The package base documents the
 * tenant-owned slots while this root preserves the generated IRI validation
 * and adds field transforms through a plain `Schema.Struct`.
 */
export const PaymentRequest = overrideSchema(
  PaymentRequestjsonldsyliusshoppaymentrequestshow,
  {}
).annotate({ identifier: 'PaymentRequest' });
export type PaymentRequest = Schema.Schema.Type<typeof PaymentRequest>;

export const PaymentRequestExtended = overrideSchema(PaymentRequest, {
  orderToken: PaymentRequestExtendedBase.fields.orderToken,
  responseData: PaymentRequestExtendedBase.fields.responseData,
}).annotate({ identifier: 'PaymentRequestExtended' });
export type PaymentRequestExtended = Schema.Schema.Type<typeof PaymentRequestExtended>;
